import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { i18n } from '../../translate/i18n';
import { Stepper, Step, StepLabel, Typography, Paper, Grid } from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import api from '../../services/api';
import toastError from "../../errors/toastError";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { pink, green } from '@material-ui/core/colors';

const ShowTicketLogModal = ({ isOpen, handleClose, ticketId }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);

  const typeDescriptions = {
    create: i18n.t("showTicketLogModal.options.create"),
    chatBot: i18n.t("showTicketLogModal.options.chatBot"),
    queue: i18n.t("showTicketLogModal.options.queue"),
    open: i18n.t("showTicketLogModal.options.open"),
    access: i18n.t("showTicketLogModal.options.access"),
    transfered: i18n.t("showTicketLogModal.options.transfered"),
    receivedTransfer: i18n.t("showTicketLogModal.options.receivedTransfer"),
    pending: i18n.t("showTicketLogModal.options.pending"),
    closed: i18n.t("showTicketLogModal.options.closed"),
    reopen: i18n.t("showTicketLogModal.options.reopen"),
    redirect: i18n.t("showTicketLogModal.options.redirect"),
    clientClosed: i18n.t("showTicketLogModal.options.clientClosed"),
    stage_changed: "Alteração de Etapa",
    tag_added: i18n.t("showTicketLogModal.options.added"),
    tag_removed: i18n.t("showTicketLogModal.options.removed")
  };

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchLogs = async () => {
        try {
          const { data } = await api.get(`/tickets-log/${ticketId}`);
          setLogs(data);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchLogs();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [ticketId]);

  const renderLogMessage = (log) => {
    if (log.type.startsWith('tag_')) {
      const action = log.type.split(':')[0];
      const tagName = log.type.split(':')[1];

      const isAdd = action === 'tag_added';

      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isAdd ? (
            <CheckCircleIcon style={{ color: green[500], marginRight: 5, fontSize: 20 }} />
          ) : (
            <HighlightOffIcon style={{ color: pink[500], marginRight: 5, fontSize: 20 }} />
          )}
          <Typography variant="body2">
            {isAdd ? i18n.t("showTicketLogModal.options.added") : i18n.t("showTicketLogModal.options.removed")} <strong>{tagName}</strong>
          </Typography>
        </div>
      );
    }

    // Default rendering for other types
    let label = typeDescriptions[log.type] || log.type;
    if (log.type === 'access' || log.type === 'transfered' || log.type === 'open' || log.type === 'pending' || log.type === "closed" || log.type === "reopen") {
      label += `: ${log?.user?.name || ''}`;
    }
    if (log.type === 'receivedTransfer') {
      label += `: ${log?.queue?.name || ''} - ${log?.user?.name || ''}`;
    }

    return <Typography variant="body2">{label}</Typography>;
  }

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{i18n.t('showTicketLogModal.title.header')}</DialogTitle>
      <DialogContent>
        <Paper elevation={0}>
          <div style={{ padding: 10 }}>
            <Stepper activeStep={activeStep} orientation="vertical">
              {logs.map((log, index) => (
                <Step key={index} active={true}>
                  <StepLabel icon={'•'} style={{ alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {renderLogMessage(log)}
                      <Typography variant="caption" color="textSecondary">
                        {format(parseISO(log?.createdAt), 'dd/MM/yyyy HH:mm')}
                      </Typography>
                    </div>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {i18n.t("showTicketLogModal.buttons.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShowTicketLogModal;
